/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { CompanySizeResource } from './';
import {
    CompanySizeResourceFromJSON,
    CompanySizeResourceFromJSONTyped,
    CompanySizeResourceToJSON,
} from './';
import type { LogoResource } from './';
import {
    LogoResourceFromJSON,
    LogoResourceFromJSONTyped,
    LogoResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyProfileResource
 */
export interface ClientCompanyProfileResource {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyProfileResource
     */
    name?: string;
    /**
     * 
     * @type {LogoResource}
     * @memberof ClientCompanyProfileResource
     */
    logo?: LogoResource;
    /**
     * 
     * @type {CompanySizeResource}
     * @memberof ClientCompanyProfileResource
     */
    size?: CompanySizeResource;
    /**
     * 
     * @type {ActivityArea}
     * @memberof ClientCompanyProfileResource
     */
    activityArea?: ActivityArea;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyProfileResource
     */
    description?: string;
}

/**
 * Check if a given object implements the ClientCompanyProfileResource interface.
 */
export function instanceOfClientCompanyProfileResource(value: object): value is ClientCompanyProfileResource {
    return true;
}

export function ClientCompanyProfileResourceFromJSON(json: any): ClientCompanyProfileResource {
    return ClientCompanyProfileResourceFromJSONTyped(json, false);
}

export function ClientCompanyProfileResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyProfileResource {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'logo': json['logo'] == null ? undefined : LogoResourceFromJSON(json['logo']),
        'size': json['size'] == null ? undefined : CompanySizeResourceFromJSON(json['size']),
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ClientCompanyProfileResourceToJSON(value?: ClientCompanyProfileResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'logo': LogoResourceToJSON(value['logo']),
        'size': CompanySizeResourceToJSON(value['size']),
        'activityArea': ActivityAreaToJSON(value['activityArea']),
        'description': value['description'],
    };
}

